import { createRemoveCollectionSyncSlice } from '@sonar-software/xuder';
import { DeleteNotificationsByIdRequest } from '../../../api';
import { NotificationsByIdName } from '../name';
import { notificationsGetSlice } from '../../@async/get';

export const removeNotificationsById = createRemoveCollectionSyncSlice({
	hasRequest: true,
	name: NotificationsByIdName,
	state: notificationsGetSlice.asyncState,
	target: (data: DeleteNotificationsByIdRequest) => (notification) => notification.notificationId === data.id
});
